exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".block{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6dd39339!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/user/ConfigResource.vue
// module id = 598
// module chunks = 2